"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeautyPoints = void 0;
var _icons = require("@ori-ui/icons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/** Helper for rendering beauty hearts or points with icon. */
const BeautyPoints = ({
  changeSymbol = '',
  points = 0,
  pointsLabel = 'points',
  pointsVisualization = 'Hearts',
  testId,
  variant = 'body1',
  ...ownerState
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BeautyPointsRoot, {
  component: "p",
  ownerState: ownerState,
  variant: variant,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    "data-testid": testId,
    children: [changeSymbol, points]
  }), pointsVisualization === 'Hearts' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.RewardsHeartsFilled, {
    fontSize: "inherit"
  }) : null, pointsVisualization === 'Points' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: ["\xA0", pointsLabel]
  }) : null]
});
exports.BeautyPoints = BeautyPoints;
